module.exports = __webpack_public_path__ + "img/simulation-bj.png";